<template>
  <v-dialog scrollable persistent class="dialog" v-model="config.status.active">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat color="secondary white--text">
          <v-toolbar-title>{{ printTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn depressed color="green darken-2 white--text" @click="openReader">
            <v-icon small>fa-file-excel</v-icon>&nbsp;から読み込む
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="form.valid" lazy-validation>
          <v-row dense class="pa-4">
            <v-col cols="12" class="secondary white--text pa-3">
              <span class="subheading">申込み内容</span>
            </v-col>
            <v-col cols="12">
              <v-text-field required v-model="form.title"
                label="申込みのタイトル"
                :rules="rules.title"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select required v-model="form.type"
                label="申込の種類"
                :items="getTypeItems"
                item-text="text"
                item-value="value"
                :rules="rules.type"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select required v-model="form.country"
                label="留学先の国"
                :items="getNationItems"
                item-text="text"
                item-value="value"
                :rules="rules.country"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field required v-model="form.city"
                label="留学先の都市"
                :rules="rules.city"
              />
            </v-col>
            <v-col cols="12" sm="6" v-if="!isAcademicCourse">
              <v-subheader class="secondary white--text">コース</v-subheader>
              <v-divider></v-divider>
              <v-list>
                <v-list-item v-for="item in getFormCourseItems" :key="item.id" class="my-3">
                  <v-list-item-avatar>
                    <v-icon small>fal fa-school</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle class="caption"><span class="font-weight-bold">レッスン内容：</span>{{ item.lesson.size + item.lesson.unit }}</v-list-item-subtitle>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle class="caption">
                      <span class="font-weight-bold">期間：</span>
                      <span v-if="item.dates && (item.dates.start + item.dates.end)">{{ (item.dates.start ? $moment(item.dates.start).format('YYYY/MM/DD') : '') + '-' + (item.dates.end ? $moment(item.dates.end).format('YYYY/MM/DD') : '') }}</span>
                      <span v-if="item.term && item.term.size">{{ item.term.size + item.term.unit }}</span>
                      <span v-if="item.extra && item.extra.size">{{ '+' + item.extra.size + item.extra.unit }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-menu bottom offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn icon small v-on="on" color="secondary" :loading="isLoading">
                          <v-icon small>fa-ellipsis-v</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="edit({ type: 'course', data: item })">
                          <v-list-item-avatar>
                            <v-icon small>fal fa-pencil</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>編集する</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="remove({ type: 'courses', data: item })">
                          <v-list-item-avatar>
                            <v-icon small>fal fa-trash-alt</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>削除する</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item @click.stop="$refs.course.open()">
                  <v-list-item-avatar>
                    <v-icon small color="secondary">fal fa-plus</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="secondary--text">コースを追加する</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon text :disabled="true"></v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="6" v-if="!isAcademicCourse">
              <v-subheader class="secondary white--text">滞在先</v-subheader>
              <v-divider></v-divider>
              <v-list>
                <v-list-item v-for="item in getFormStayItems" :key="item.id" class="my-3">
                  <v-list-item-avatar>
                    <v-icon small>fal fa-bed</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle class="caption"><span class="font-weight-bold">宿泊タイプ：</span>{{ item.type }}</v-list-item-subtitle>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle class="caption">
                      <span class="font-weight-bold">期間：</span>
                      <span v-if="item.dates && (item.dates.start + item.dates.end)">{{ (item.dates.start ? $moment(item.dates.start).format('YYYY/MM/DD') : '') + '-' + (item.dates.end ? $moment(item.dates.end).format('YYYY/MM/DD') : '') }}</span>
                      <span v-if="item.term && item.term.size">{{ item.term.size + item.term.unit }}</span>
                      <span v-if="item.extra && item.extra.size">{{ '+' + item.extra.size + item.extra.unit }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-menu bottom offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn icon small v-on="on" color="secondary" :loading="isLoading">
                          <v-icon small>fa-ellipsis-v</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="edit({ type: 'stay', data: item })">
                          <v-list-item-avatar>
                            <v-icon small>fal fa-pencil</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>編集する</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="remove({ type: 'stays', data: item })">
                          <v-list-item-avatar>
                            <v-icon small>fal fa-trash-alt</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>削除する</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item @click.stop="$refs.stay.open()">
                  <v-list-item-avatar>
                    <v-icon small color="secondary"></v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="secondary--text">滞在先を追加する</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon text :disabled="true"></v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
            <CourseModal ref="course" @done="insertItem"></CourseModal>
            <StayModal ref="stay" @done="insertItem"></StayModal>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary"
          :loading="isLoading"
          :disabled="!isValid" @click.stop="isTypeInsert ? insert() : (isTypeUpdate ? update() : null)"
        >{{ isTypeInsert ? '登録する' : (isTypeUpdate ? '更新する' : '') }}</v-btn>
      </v-card-actions>
      <ReaderModal ref="reader" @done="overwrite" />
    </v-card>
  </v-dialog>
</template>

<script>
import CourseModal from '../course'
import StayModal from '../stay'
import ReaderModal from '../program/modals/reader'
const DEF = {
  TYPE: 'insert',
  PAGE: 'main'
}
export default {
  name: 'ProgramModal',
  components: {
    CourseModal,
    StayModal,
    ReaderModal
  },
  data () {
    return {
      config: {
        type: DEF.TYPE,
        status: {
          active: false,
          loading: false
        }
      },
      meta: {
        types: {
          'prog-short': '短期留学',
          'prog-long': '長期留学',
          'prog-wh': 'ワーホリ',
          'prog-academic': '高校・大学正規留学'
        }
      },
      form: {
        valid: true,
        id: '',
        type: '',
        title: '',
        country: '',
        city: '',
        courses: [],
        stays: []
      },
      rules: {
        type: [
          v => !!v || '必須項目です'
        ],
        country: [
          v => !!v || '必須項目です'
        ],
        city: [
          v => !!v || '必須項目です'
        ],
        title: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    validate: function (status) {
      if (status == null) {
        this.$refs.form.validate()
      } else {
        this.$set(this.form, 'valid', status)
      }
    },
    page: function (req) {
      const { dest, data } = req || {}
      if (dest) {
        this.$set(this.form, 'valid', true)
        this.$set(this.config, 'page', dest)
      }
    },
    read: function (req) {
      const { item, config } = req || {}
      if (item && item.id && config) {
        this.submit({
          type: 'read',
          id: item.id,
          config
        })
      }
    },
    insert: function () {
      this.submit({
        type: 'insert',
        form: this.form
      })
    },
    update: function () {
      this.submit({
        type: 'update',
        id: this.form.id,
        form: this.form
      })
    },
    preSubmit: function (req) {
      const { type, id, form, config } = req
      const cid = this.$route.params.id
      const urls = {
        insert: `${this.$url.api}apply/insert/item/${cid}`,
        update: `${this.$url.api}apply/update/item/${id}`,
      }
      const fds = {
        insert: { form },
        update: { form }
      }
      if (urls[type] && fds[type]) {
        const url = urls[type]
        const fd = fds[type]
        this.$set(this.config.status, 'loading', true)
        return { url, fd }
      } else {
        return false
      }
    },
    submit: function (req) {
      const { type } = req
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            },
            onUploadProgress: (e) => {
              this.$set(this.config.status, 'loading', Math.ceil(e.loaded / e.total * 100))
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({ type, data: res.data.data})
            } else {
              this.failSubmit(res.data)
            }
          })
        }).catch(err => {
          console.log(err)
          this.failSubmit(err)
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req
      if (type === 'insert' || type === 'update') {
        this.$emit('done', data)
        this.close()
      }
      this.$set(this.config.status, 'loading', false)
    },
    failSubmit: function (req) {
      const { message } = req
      if (message) {
        const err = this.$error.xlsx.read[message] ? this.$error.xlsx.read[message] : ''
        if (err) {
          this.$store.dispatch('notifier/addAlert', {
            title: '読み込みの失敗',
            message: err
          })
        }
      }
      this.$set(this.config.status, 'loading', false)
    },
    edit: function (req) {
      const { type, data } = req || {}
      const { id } = data || {}
      if (type && data && id && this.$refs[type]) {
        this.$refs[type].open(data)
      }
    },
    remove: function (req) {
      const { type, data } = req || {}
      const { id } = data || {}
      const fm = this.form[type] || []
      if (type && data && id && fm.length) {
        let idx = fm.findIndex(it => {
          return it.id === id
        })
        if (idx >= 0) {
          this.form[req.type].splice(idx, 1)
        }
      }
    },
    overwrite: function (req) {
      const { item } = req
      let idx = Object.keys(this.$mango.nations).findIndex(key => {
        return (this.$mango.nations[key] === item.country)
      })
      const nationCode = (idx >= 0) ? Object.keys(this.$mango.nations)[idx] : ''
      this.$set(this, 'form', {
        valid: true,
        id: item.id || '',
        title: item.title || '',
        country: nationCode,
        city: item.city || '',
        courses: item.courses || [],
        stays: item.stays || []
      })
    },
    open: function (req) {
      const { type, item } = req || {}
      this.$set(this.config, 'type', type || DEF.TYPE)
      this.$set(this, 'form', {
        valid: true,
        id: item ? item.id : '',
        type: item ? item.type : '',
        title: item ? item.title : '',
        country: item ? item.country : '',
        city: item ? item.city : '',
        courses: item ? JSON.parse(JSON.stringify(item.courses)) : [],
        stays: item ? JSON.parse(JSON.stringify(item.stays)) : []
      })
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    insertItem: function (req) {
      const { type, data } = req || {}
      const { id } = data || {}
      if (id) {
        let idx = this.form[type].findIndex(it => {
          return it.id === id
        })
        if (idx >= 0) {
          this.form[type].splice(idx, 1, data)
        } else {
          this.form[type].push(data)
        }
      }
    },
    openReader: function () {
      this.$refs.reader.open()
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading !== false
    },
    getType () {
      return this.config.type
    },
    isTypeInsert () {
      return this.config.type === 'insert'
    },
    isTypeUpdate () {
      return this.config.type === 'update'
    },
    getFormData () {
      return this.form
    },
    getStatus () {
      return this.config.status
    },
    printTitle () {
      if (this.config.type === 'insert') {
        return '新規申込の追加'
      } else if (this.config.type === 'update') {
        return '申込内容の編集'
      } else {
        return ''
      }
    },
    isAcademicCourse () {
      return this.form.type === 'acadmic'
    },
    getTypeItems () {
      return Object.keys(this.$mango.arrange.types).map(key => {
        return {
          text: this.$mango.arrange.types[key],
          value: key
        }
      })
    },
    getNationItems () {
      return Object.keys(this.$mango.nations).filter(key => {
        return key !== 'JP'
      }).map(key => {
        return {
          text: this.$mango.nations[key],
          value: key
        }
      })
    },
    getFormCourseItems () {
      return this.form.courses
    },
    getFormStayItems () {
      return this.form.stays
    }
  }
}
</script>
